import { useAnimatedStyle, interpolate, Extrapolation, } from 'react-native-reanimated';
export const useAnimatedUtilityStyles = (position) => {
    const bodyOpacityStyle = useAnimatedStyle(() => {
        const opacity = interpolate(position.value, [0, 1], [0, 1], Extrapolation.CLAMP);
        return { opacity };
    }, []);
    const bodyHideStyle = useAnimatedStyle(() => {
        const opacity = position.value > 0 ? 1 : 0;
        return { opacity };
    }, []);
    return {
        bodyOpacityStyle,
        bodyHideStyle,
    };
};
//# sourceMappingURL=useAnimatedUtilityStyles.js.map